import React, { useState } from 'react';
import styles from './Avatar.module.scss';
import DefaultContactIcon from './DefaultContactIcon';

interface AvatarProps {
  src: string;
  alt: string;
  name: string;
  size?: number;
}

const Avatar: React.FC<AvatarProps> = ({ src, alt, name, size = 32 }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  // Check if this is a LDAP image URL that might not exist
  const isLDAPImage = src && src.includes('s7d2.scene7.com/is/image/IMGDIR/');

  // Show default contact icon if image fails to load or is invalid
  if (
    imageError ||
    !src ||
    src.includes('placeholder') ||
    (isLDAPImage && imageError)
  ) {
    return (
      <div className={styles.avatarFallback}>
        <DefaultContactIcon size={size} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={styles.avatarImage}
      onError={handleImageError}
      onLoad={handleImageLoad}
    />
  );
};

export default Avatar;
